import React from "react";

import XeroCallbackContent from "../components/payments-linking/xero-callback-content.js";

const XeroCallback = () => {
  return <XeroCallbackContent />;
};

export default XeroCallback;
